/* eslint-disable camelcase, max-lines-per-function */

import { api } from "jiffy-api";
import "./product-details-delivery-date.scss";
import { EventBus, Events, store } from "jiffy-store";
import { sendDataLayer } from "jiffy-analytics";

const SELECTORS = {
  DATES_CONTAINER: ".js-product-details",
  CONTAINER: ".js-product-details-delivery-date",
  J1ST_DATE_WRAPPER: ".js-product-details-delivery-date-j1st-wrapper",
  J1ST_DATE_CONTAINER: ".js-product-details-delivery-date-j1st",
  REGULAR_DATE_WRAPPER: ".js-product-details-delivery-date-regular-wrapper",
  REGULAR_DATE_CONTAINER: ".js-product-details-delivery-date-regular",
  REGULAR_DATE_TITLE: ".js-product-details-delivery-date-regular-title",
  REGULAR_DATE_COLON: ".js-product-details-delivery-date-regular-colon",
  FULL_HIDDEN_CLASS: "hidden"
};

const insertDeliveryDates = ({ jiffy_first, regular }) => {
  const container = document.querySelector(SELECTORS.CONTAINER);
  const j1stDateWrapper = document.querySelector(SELECTORS.J1ST_DATE_WRAPPER);
  const j1stDateContainer = document.querySelector(SELECTORS.J1ST_DATE_CONTAINER);
  const regularDateWrapper = document.querySelector(SELECTORS.REGULAR_DATE_WRAPPER);
  const regularDateContainer = document.querySelector(SELECTORS.REGULAR_DATE_CONTAINER);
  const regularDateTitle = document.querySelector(SELECTORS.REGULAR_DATE_TITLE);
  const regularDateColon = document.querySelector(SELECTORS.REGULAR_DATE_COLON);

  j1stDateContainer.innerHTML = jiffy_first;
  regularDateContainer.innerHTML = regular;
  container.classList.toggle(SELECTORS.FULL_HIDDEN_CLASS, !jiffy_first && !regular);
  j1stDateWrapper.classList.toggle(SELECTORS.FULL_HIDDEN_CLASS, !jiffy_first);
  regularDateWrapper.classList.toggle(SELECTORS.FULL_HIDDEN_CLASS, !regular);
  regularDateTitle.classList.toggle(SELECTORS.FULL_HIDDEN_CLASS, !jiffy_first);
  regularDateColon.classList.toggle(SELECTORS.FULL_HIDDEN_CLASS, !jiffy_first);
};

const getDeliveryDates = (color, type = "dates") => {
  const deliveryEstimate = window.delivery_estimates.find(({ group_name }) => color === group_name);

  let dates = { jiffy_first: null, regular: null };

  if (deliveryEstimate) {
    dates = deliveryEstimate[type];
  }

  return dates;
};

export default () => {
  const container = document.querySelector(SELECTORS.CONTAINER);
  window.delivery_estimates = window.delivery_estimates || [];

  if (container) {
    sendDataLayer({
      genericEvent: true,
      eventCategory: "PDP",
      event: "Display",
      eventLabel: "J1st Estimated Delivery Dates"
    });

    const { productId, debugEnabled } = document.querySelector(SELECTORS.CONTAINER).dataset;
    let { selectedColor } = document.querySelector(SELECTORS.CONTAINER).dataset;
    loadDeliveryEstimates(productId, debugEnabled);

    EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
      insertDeliveryDates(getDeliveryDates(color, "dates"));
      selectedColor = color;
    });

    store.ui.changed((_, { data }) => {
      if (!data.shopBy) return;

      if (data.shopBy === "case") {
        insertDeliveryDates(getDeliveryDates(selectedColor, "cased_variants_dates"));
      } else {
        insertDeliveryDates(getDeliveryDates(selectedColor, "dates"));
      }
    });
  }
};

async function fetchDeliveryEstimates(payload, debugEnabled) {
  const options = {};
  if (debugEnabled === "true") {
    options.debug = "1";
  }

  const response = await api.product.fetchDeliveryEstimates(payload, options);

  if (response.success === true) {
    window.delivery_estimates = response.dates;
  }
}

function loadDeliveryEstimates(productId, debugEnabled) {
  fetchDeliveryEstimates({ productId }, debugEnabled);
}
